import { CarFuelType, CarRefItemStatus } from "../constants/car-basic-data";

export class CarEngine {
    id: number = 0;
    
    code = '';
    name = '';
    details = '';
    ref = '';

    manufacturerId: number = 0;
    manufacturerCode: string = '';
    manufacturerName: string = '';

    fuel: CarFuelType = CarFuelType.DIESEL;
    cylinder: number = 0;
    powerHp: number = 0;
    powerKw: number = 0;
    
    startYear = 1900;
    endYear = 2099;

    status: CarRefItemStatus = CarRefItemStatus.REVIEW;
    created = '';
    lastUpdated = '';
    lastUpdatedBy = '';
  
    constructor (code: string, name: string)  {
        this.code = code!;
        this.name = name!;
    }
  }

  